import { toCurrency } from "./numberFormatter";
import _debounce from 'lodash/debounce';

export const getSafeValue = (value: any) => (isNaN(value) ? '-' : toCurrency(value));
export const getFormattedValue = (value: any, isInvalid: boolean) => (isInvalid ? '- €' : getSafeValue(value));

export const getSafeDefaultValue = ({
    defaultValue,
    value,
    max,
    min,
}: {
    value: string | string[], defaultValue: number, min?: number, max?: number
}) => {
    if (Array.isArray(value)) {
        return defaultValue;
    }

    const parsedValue = Number(value);
    if (isNaN(parsedValue)) {
      return defaultValue;
    }
    if (min !== undefined && parsedValue < min) {
      return defaultValue;
    }
    if (max !== undefined && parsedValue > max) {
      return defaultValue;
    }
    return Number(value);
};

export const updateSimulatorQueryParams = _debounce((values) => {
    window.history.replaceState(null, null, `?${new URLSearchParams(values).toString()}`);
}, 700);

/**
 * Assumption: the insurance rate is a monthly constant rate
 */
export const calculateMonthlyPaymentWithInsurance = ({
  insuranceRate,
  interestRate,
  loanCapital,
  months,
}: {
  loanCapital: number, interestRate: number, months: number, insuranceRate: number
}) => {
  const monthlyInterestRate = interestRate / 12;
  const denominator = 1 - Math.pow(1 + monthlyInterestRate, -months);
  const monthlyPaymentWithoutInsurance = (loanCapital * monthlyInterestRate) / (denominator || 1);
  const insurancePayment = loanCapital * insuranceRate / 12;
  const totalMonthlyPayment = monthlyPaymentWithoutInsurance + insurancePayment;

  return totalMonthlyPayment;
}

export const calculateMonthlyPaymentGraphData = ({
insurancePerMonth,
interestRate,
loanCapital,
monthlyPayments,
numbersOfYears
}: { numbersOfYears: number; interestRate: number; monthlyPayments: number; loanCapital: number; insurancePerMonth: number; }) => {
  const monthsData: {
    year: number;
    interests: number;
    capital: number;
    insurance: number;
    remainingBalance: number;
    monthlyPayments: number;
  }[] = [];

  const months = numbersOfYears * 12

  for (let i = 0; i < months; i++) {
    const year = Math.floor(i / 12) + 1;
    const previousRemainingBalance = monthsData.length > 0 ? monthsData[i - 1].remainingBalance : loanCapital;
    const interests = previousRemainingBalance * interestRate / 12;
    const capital = monthlyPayments - interests - insurancePerMonth;

    monthsData.push({
      year,
      interests,
      capital,
      insurance: insurancePerMonth,
      remainingBalance: previousRemainingBalance - capital,
      monthlyPayments,
    })
  }

  return Array.from({ length: numbersOfYears }, (_, index) => {
    const year = index + 1
    const item = monthsData[index * 12] // get the first month of the year
    const { interests, capital, insurance } = item;

    return {
      year,
      interests,
      capital,
      insurance,
    }
  })
}